import { render, staticRenderFns } from "./ChartCategoryToReceive.vue?vue&type=template&id=b9294cbc&scoped=true&"
import script from "./ChartCategoryToReceive.vue?vue&type=script&lang=js&"
export * from "./ChartCategoryToReceive.vue?vue&type=script&lang=js&"
import style0 from "./ChartCategoryToReceive.vue?vue&type=style&index=0&id=b9294cbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9294cbc",
  null
  
)

export default component.exports